import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { BootstrapModalModule } from 'ngx-bootstrap-modal';
import { DialogYesComponent, DialogYesNoCancelComponent, DialogYesNoComponent, FooterComponent, HeaderComponent, HeaderMenuComponent, LeftComponent, MessageInfoComponent, MessageInfoDetailComponent } from './component';
import { DoubleClickPreventionDirective, WindowCloseDirective } from './utility';
import { JuchuNoFilter, ZipCodeFilter, NumericFilter, Null2BarFilter, DateFilter, HourFilter, HtmlFilter } from './pipes';
import { N2013Component } from '../n201/n2013.component';
import { N2014Component } from '../n201/n2014.component';
import { N2025Component } from '../n202/n2025.component';
import { N3026Component } from '../n302/n3026.component';
import { N5111Component } from '../n511/n5111.component';
import { N4074Component } from '../n407/n4074.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    BsDatepickerModule.forRoot(),
    RouterModule.forChild([
      { path: 'header', component: HeaderMenuComponent, pathMatch: 'full' },
    ])
  ],
  declarations: [
    DoubleClickPreventionDirective,
    DialogYesComponent,
    DialogYesNoComponent,
    DialogYesNoCancelComponent,
    LeftComponent,
    HeaderComponent,
    HeaderMenuComponent,
    FooterComponent,    
    MessageInfoComponent,
    MessageInfoDetailComponent,
    WindowCloseDirective,
    JuchuNoFilter,
    ZipCodeFilter,
    NumericFilter,
    DateFilter,
    HourFilter,
    Null2BarFilter,
    HtmlFilter,
    N2013Component,
    N2014Component,
    N2025Component,
    N3026Component,
    N4074Component,
    N5111Component],
  providers: [
  ],
  entryComponents: [DialogYesComponent, DialogYesNoComponent, HeaderMenuComponent, N2013Component, N2014Component, N2025Component, N3026Component, N4074Component, N5111Component],
  exports: [  
    CommonModule,
    FormsModule,
    NgbModule,
    BootstrapModalModule,
    BsDatepickerModule,
    DoubleClickPreventionDirective,
    DialogYesComponent,
    DialogYesNoComponent,
    DialogYesNoCancelComponent,
    LeftComponent,
    HeaderComponent,
    HeaderMenuComponent,
    FooterComponent,
    MessageInfoComponent,
    MessageInfoDetailComponent,
    WindowCloseDirective,
    JuchuNoFilter,
    ZipCodeFilter,
    Null2BarFilter,
    NumericFilter,
    DateFilter,
    HourFilter,
    HtmlFilter,
    N2013Component,
    N2014Component,
    N2025Component,
    N3026Component,
    N4074Component,
    N5111Component
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/modules/shared/shared.module.ts